import { LinearProgress, makeStyles, Typography } from "@material-ui/core";
import { grey, orange, red } from "@material-ui/core/colors";
import { get } from "lodash";
import React from "react";

const styles = (theme) => ({
	stat: {
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1),
		"&:first-child": {
			paddingLeft: theme.spacing(0),
		},
	},
	danger: {
		color: red[500],
	},
	warning: {
		color: orange[500],
		fontWeight: "bold",
	},
	verbose: {
		color: grey[500],
	},
});

const useStyles = makeStyles(styles);

const ChannelStatsField = ({ source, record }) => {
	const classes = useStyles();
	const stats = get(record, source);
	if (!stats) {
		return <LinearProgress />;
	}
	const total = get(stats, "total");
	const used = get(stats, "used");
	const free = total - used;
	const maxLinks = get(stats, "max_links");

	let targetClass = null;
	if (free === 0) {
		targetClass = classes.danger;
	} else if (free < maxLinks) {
		targetClass = classes.warning;
	} else {
		targetClass = classes.verbose;
	}
	return (
		<Typography className={targetClass}>
			<span className={classes.stat}>{free}</span>/
			<span className={classes.stat}>{total}</span>/
			<span className={classes.stat}>{maxLinks}</span>
		</Typography>
	);
};

export default ChannelStatsField;
